import { io, Socket } from 'socket.io-client'

// Single shared socket to the back-office server (same origin: the page is served
// by the same express/vite-express instance that hosts socket.io).
let socket: Socket | null = null

export function getSocket(): Socket {
    if (!socket) socket = io({ autoConnect: true })
    return socket
}
